import { gql } from '@apollo/client';

export default gql`
  query journeySearch(
    $origin: String!
    $destination: String!
    $returningOrigin: String
    $returningDestination: String
    $outboundDate: String
    $inboundDate: String
    $adults: Int
    $adults12To15: Int
    $adults16Plus: Int
    $children: Int
    $children5To11: Int
    $children4Only: Int
    $infants: Int
    $youths: Int
    $seniors: Int
    $adultsWheelchair: Int
    $childrenWheelchair: Int
    $guideDogs: Int
    $wheelchairCompanions: Int
    $nonWheelchairCompanions: Int
    $productFamilies: [String]
    $contractCode: String
    $currency: Currency
    $passengers: [InputPassengerBrief]
    $multipleFlexibility: Boolean
    $isYouthAdultConversionActive: Boolean
    $offerSummatedFares: Boolean
    $maxTransfers: Int
    $subscriptionCode: TravelPassTemplateCode
    $discountCards: [InputDiscountCard]
    $useNewLoyaltySystem: Boolean
    $seniorsAges: [Int!]
    $youthAges: [Int!]
    $childAges: [Int!]
    $adultsEvac: Int
    $childrenEvac: Int
  ) {
    journeySearch(
      outboundDate: $outboundDate
      inboundDate: $inboundDate
      origin: $origin
      destination: $destination
      returningOrigin: $returningOrigin
      returningDestination: $returningDestination
      adults: $adults
      adults12To15: $adults12To15
      adults16Plus: $adults16Plus
      children: $children
      children4Only: $children4Only
      children5To11: $children5To11
      infants: $infants
      youths: $youths
      seniors: $seniors
      adultsWheelchair: $adultsWheelchair
      childrenWheelchair: $childrenWheelchair
      guideDogs: $guideDogs
      wheelchairCompanions: $wheelchairCompanions
      nonWheelchairCompanions: $nonWheelchairCompanions
      currency: $currency
      productFamilies: $productFamilies
      contractCode: $contractCode
      passengersList: $passengers
      multipleFlexibility: $multipleFlexibility
      isYouthAdultConversionActive: $isYouthAdultConversionActive
      offerSummatedFares: $offerSummatedFares
      maxTransfers: $maxTransfers
      subscriptionCode: $subscriptionCode
      discountCards: $discountCards
      useNewLoyaltySystem: $useNewLoyaltySystem
      seniorsAges: $seniorsAges
      youthAges: $youthAges
      childAges: $childAges
      adultsEvac: $adultsEvac
      childrenEvac: $childrenEvac
    ) {
      outbound {
        ...offer
      }
      inbound {
        ...offer
      }
      passengers {
        id
        type
        birthDate
        disabilityType
      }
      productFamiliesWithFares @client
    }
  }

  fragment offer on Offer {
    origin {
      uic
      name
      shortCode
    }
    destination {
      uic
      name
      shortCode
    }
    productFamilies {
      name
      code
      familyGroup
      familyGroupName
    }
    productFamiliesWithFares @client
    classesOfService {
      code
      name
    }
    journeys(hideDirectExternalCarrierTrains: true) {
      timing {
        date
        departs
        arrives
        duration
      }
      fares {
        buckets {
          code
          price
          passengerType
          availability
          physicalAvailability
          highestBucketCodeLogicalAvailability
        }
        legs {
          trainNumber
          serviceName
          serviceIdentifier
          serviceType {
            name
            code
            brandCode
          }
          origin {
            name
            uic
            shortCode
          }
          destination {
            name
            uic
            shortCode
          }
          timing {
            departureDate
            departs
            arrives
            duration
          }
          products {
            name
            isFareAddOn
            passengerId
            tariffCode
            bucketCode
            code
            loyaltyPoints
            price
          }
          classOfService {
            code
            name
          }
          addOnProducts {
            availabilityOfClassOfService
          }
        }
        offlineFee @client
        isLyria @client
        isSummatedFare
        isThroughFare
        fees {
          tariffCode
          price
          name
          passengerId
          code
        }
        classOfService {
          code
          name
        }
        canBeBooked
        flexibilityLevel
        prices {
          displayPrice
        }
        promo {
          type
          value
        }
        productFamily {
          code
          name
          familyGroup
          familyGroupName
        }
        bookingItems {
          name
          isAFareAddOn
          passengerId
          tariffCode
          price
          loyaltyPoints
        }
        __typename
      }
    }
  }
`;
